import { render, staticRenderFns } from "./AssignEmptyPlaceModal.vue?vue&type=template&id=019cf85a"
import script from "./AssignEmptyPlaceModal.vue?vue&type=script&lang=ts"
export * from "./AssignEmptyPlaceModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports